// import colors from '@rezdy/components/utils/colors';

export const blue = '#0046D1';
export const rowGap = '24px';
